// extracted by mini-css-extract-plugin
export default {"collections-list-wrapper":"CollectionSearch_collections-list-wrapper__B4mUu","collectionsListWrapper":"CollectionSearch_collections-list-wrapper__B4mUu"};